import type { ReactNode } from 'react';
import U2000RequireRole from '../u2000Core/components/controls/U2000RequireRole';
import U3147, { U3147ROLES } from './U3147';

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3147Routes: RouteObject[] = [
  {
    path: 'U3147',
    element: <U2000RequireRole allowedRoles={[U3147ROLES.READ]} />,
    children: [{ path: ':view?', element: <U3147 /> }],
  },
];

export default U3147Routes;
